module.exports = __webpack_public_path__ + "static/img/person_1.180bdf8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/person_1.jpg
// module id = /KzN
// module chunks = 0